import { Box, Button, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import Iconify from '../Iconify';

export function AppErrorFallback({ error, resetErrorBoundary }) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
        backgroundColor: '#F6F6F6',
      }}
    >
      <Box
        sx={{
          maxWidth: 520,
          width: '100%',
          backgroundColor: '#fff',
          borderRadius: 2,
          boxShadow: '0 12px 40px rgba(0,0,0,0.08)',
          p: 4,
          textAlign: 'center',
        }}
      >
        <Iconify icon="mdi:alert-circle-outline" width={48} height={48} color="#EA5E00" />
        <Typography variant="h5" sx={{ mt: 2, mb: 1, color: '#182E45', fontWeight: 700 }}>
          L&apos;application a rencontré un problème
        </Typography>
        <Typography sx={{ color: '#3F5265', mb: 3, lineHeight: 1.6 }}>
          Un incident inattendu s&apos;est produit. Rechargez la page — si le problème survient
          après un déploiement, cela met généralement l&apos;application à jour.
        </Typography>
        {process.env.NODE_ENV === 'development' && error?.message && (
          <Typography
            component="pre"
            sx={{
              textAlign: 'left',
              fontSize: 12,
              color: '#637381',
              backgroundColor: '#F9FAFB',
              p: 2,
              borderRadius: 1,
              overflow: 'auto',
              mb: 3,
            }}
          >
            {error.message}
          </Typography>
        )}
        <Button
          variant="contained"
          onClick={() => {
            resetErrorBoundary();
            window.location.reload();
          }}
          sx={{
            backgroundColor: '#EA5E00',
            '&:hover': { backgroundColor: '#c44f00' },
            textTransform: 'none',
            fontWeight: 600,
          }}
        >
          Recharger l&apos;application
        </Button>
      </Box>
    </Box>
  );
}

AppErrorFallback.propTypes = {
  error: PropTypes.shape({ message: PropTypes.string }),
  resetErrorBoundary: PropTypes.func.isRequired,
};
